/** @format */

// 下发状态，(00：下发中 ，01：下发成功，02下发失败，03：无需下发)

export enum DictIssuedStatus {
  Load = '00',
  Suceess = '01',
  Fail = '02',
  Dont = '03'
}

export const dictIssuedStatusMap: {
  [key: string]: string;
} = {
  [DictIssuedStatus.Load]: '下发中',
  [DictIssuedStatus.Suceess]: '下发成功',
  [DictIssuedStatus.Fail]: '下发失败',
  [DictIssuedStatus.Dont]: '无需下发'
};
